import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';

/* ================== ACTION TYPES ================== */
export const CONTACT_ADD = 'CONTACT_ADD';
export const CONTACT_GET_ALL = 'CONTACT_GET_ALL';
export const CONTACT_SEARCH = 'CONTACT_SEARCH';
export const CONTACT_GET_BY_ID = 'CONTACT_GET_BY_ID';
export const CONTACT_UPDATE = 'CONTACT_UPDATE';
export const CONTACT_DELETE = 'CONTACT_DELETE';
export const CONTACT_MULTIPLE_DELETE = 'CONTACT_MULTIPLE_DELETE';
export const CONTACT_IMPORT = 'CONTACT_IMPORT';
export const CONTACT_EXPORT = 'CONTACT_EXPORT';
export const CONTACT_CHAT_LIST = 'CONTACT_CHAT_LIST';

export const CAMPAIGN_SEND = 'CAMPAIGN_SEND';
export const CAMPAIGN_GET_ALL = 'CAMPAIGN_GET_ALL';
export const CAMPAIGN_REPORT = 'CAMPAIGN_REPORT';
export const CAMPAIGN_SINGLE_SEND = 'CAMPAIGN_SINGLE_SEND';
export const CAMPAIGN_LOGS = 'CAMPAIGN_LOGS';
export const CAMPAIGN_DASHBOARD_SUMMARY = 'CAMPAIGN_DASHBOARD_SUMMARY';
export const CAMPAIGN_REPORT_CONTACTS = 'CAMPAIGN_REPORT_CONTACTS';

export const TEMPLATE_GET_ALL = 'TEMPLATE_GET_ALL';
export const TEMPLATE_CREATE = 'TEMPLATE_CREATE';

export const GROUP_CREATE = 'GROUP_CREATE';
export const GROUP_GET_ALL = 'GROUP_GET_ALL';
export const GROUP_DELETE = 'GROUP_DELETE';
export const GROUP_CONTACTS = 'GROUP_CONTACTS';
export const GROUP_GET_BY_ID = 'GROUP_GET_BY_ID';
export const GROUP_ADD_CONTACT = 'GROUP_ADD_CONTACT';

export const MESSAGE_SEND = 'MESSAGE_SEND';
export const MESSAGE_GET_CHAT = 'MESSAGE_GET_CHAT';
export const MEDIA_UPLOAD = 'MEDIA_UPLOAD';
export const CREDENTIALS_GET = 'CREDENTIALS_GET';

/* ================== ACTION CREATORS (payload wrap) ================== */
const contactAddAction = (payload) => ({ type: CONTACT_ADD, payload });
const contactGetAllAction = (payload) => ({ type: CONTACT_GET_ALL, payload });
const contactSearchAction = (payload) => ({ type: CONTACT_SEARCH, payload });
const contactGetByIdAction = (payload) => ({
  type: CONTACT_GET_BY_ID,
  payload,
});
const contactUpdateAction = (payload) => ({ type: CONTACT_UPDATE, payload });
const contactDeleteAction = (payload) => ({ type: CONTACT_DELETE, payload });
const contactMultipleDeleteAction = (payload) => ({
  type: CONTACT_MULTIPLE_DELETE,
  payload,
});
const contactImportAction = (payload) => ({ type: CONTACT_IMPORT, payload });
const contactExportAction = (payload) => ({ type: CONTACT_EXPORT, payload });
const contactChatListAction = (payload) => ({
  type: CONTACT_CHAT_LIST,
  payload,
});

const campaignSendAction = (payload) => ({ type: CAMPAIGN_SEND, payload });
const campaignGetAllAction = (payload) => ({ type: CAMPAIGN_GET_ALL, payload });
const campaignReportAction = (payload) => ({ type: CAMPAIGN_REPORT, payload });
const campaignSingleSendAction = (payload) => ({
  type: CAMPAIGN_SINGLE_SEND,
  payload,
});
const campaignLogsAction = (payload) => ({ type: CAMPAIGN_LOGS, payload });
const campaignDashboardSummaryAction = (payload) => ({
  type: CAMPAIGN_DASHBOARD_SUMMARY,
  payload,
});
const campaignReportContactsAction = (payload) => ({
  type: CAMPAIGN_REPORT_CONTACTS,
  payload,
});

const templateGetAllAction = (payload) => ({ type: TEMPLATE_GET_ALL, payload });
const templateCreateAction = (payload) => ({ type: TEMPLATE_CREATE, payload });

const groupCreateAction = (payload) => ({ type: GROUP_CREATE, payload });
const groupGetAllAction = (payload) => ({ type: GROUP_GET_ALL, payload });
const groupDeleteAction = (payload) => ({ type: GROUP_DELETE, payload });
const groupContactsAction = (payload) => ({ type: GROUP_CONTACTS, payload });
const groupGetByIdAction = (payload) => ({ type: GROUP_GET_BY_ID, payload });
const groupAddContactAction = (payload) => ({
  type: GROUP_ADD_CONTACT,
  payload,
});

const messageSendAction = (payload) => ({ type: MESSAGE_SEND, payload });
const messageGetChatAction = (payload) => ({ type: MESSAGE_GET_CHAT, payload });
const mediaUploadAction = (payload) => ({ type: MEDIA_UPLOAD, payload });
const credentialsGetAction = (payload) => ({ type: CREDENTIALS_GET, payload });

const authHeader = () => ({
  headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
});

/* ===================================================================
   CONTACT
=================================================================== */
export const addContact = (payload, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .post(`${BASEURL}/chatbox/contact/create`, payload, authHeader())
        .then((res) => {
          toast.success('Contact Added Successfully');
          dispatch(contactAddAction(res));
          dispatch(getAllContacts(limits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(contactAddAction(error?.response));
        });
    } catch (error) {
      console.log('Error addContact', error);
    }
  };
};

export const getAllContacts = (params) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({
        page: params?.page || 1,
        limit: params?.limit || 10,
        search: params?.search || '',
        subscribed: params?.subscribed ?? '',
      }).toString();
      await axios
        .get(`${BASEURL}/chatbox/contact/getAll?${query}`, authHeader())
        .then((res) => dispatch(contactGetAllAction(res)))
        .catch((error) => dispatch(contactGetAllAction(error?.response)));
    } catch (error) {
      console.log('Error getAllContacts', error);
    }
  };
};

export const searchContacts = (params) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams(params).toString();
      await axios
        .get(`${BASEURL}/chatbox/contact/getAll?${query}`, authHeader())
        .then((res) => dispatch(contactSearchAction(res)))
        .catch((error) => dispatch(contactSearchAction(error?.response)));
    } catch (error) {
      console.log('Error searchContacts', error);
    }
  };
};

export const getContactById = (id) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/contact/get/${id}`, authHeader())
        .then((res) => dispatch(contactGetByIdAction(res)))
        .catch((error) => dispatch(contactGetByIdAction(error?.response)));
    } catch (error) {
      console.log('Error getContactById', error);
    }
  };
};

export const updateContact = (id, payload, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .put(`${BASEURL}/chatbox/contact/update/${id}`, payload, authHeader())
        .then((res) => {
          toast.success('Contact Updated Successfully');
          dispatch(contactUpdateAction(res));
          dispatch(getAllContacts(limits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(contactUpdateAction(error?.response));
        });
    } catch (error) {
      console.log('Error updateContact', error);
    }
  };
};

export const deleteContact = (id, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .delete(`${BASEURL}/chatbox/contact/delete/${id}`, authHeader())
        .then((res) => {
          toast.success('Contact Deleted Successfully');
          dispatch(contactDeleteAction(res));
          dispatch(getAllContacts(limits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(contactDeleteAction(error?.response));
        });
    } catch (error) {
      console.log('Error deleteContact', error);
    }
  };
};

export const multipleDeleteContact = (contactIds, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${BASEURL}/chatbox/contact/multipleDelete`,
          { contactIds },
          authHeader(),
        )
        .then((res) => {
          toast.success('Selected Contacts Deleted Successfully');
          dispatch(contactMultipleDeleteAction(res));
          dispatch(getAllContacts(limits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(contactMultipleDeleteAction(error?.response));
        });
    } catch (error) {
      console.log('Error multipleDeleteContact', error);
    }
  };
};

export const importContacts = (formData, limits) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${BASEURL}/chatbox/contact/import-contacts`,
          formData,
          authHeader(),
        )
        .then((res) => {
          toast.success(res?.data?.message || 'Contacts Imported Successfully');
          dispatch(contactImportAction(res));
          dispatch(getAllContacts(limits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(contactImportAction(error?.response));
        });
    } catch (error) {
      console.log('Error importContacts', error);
    }
  };
};

export const exportContacts = (params) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams(params).toString();
      await axios
        .get(`${BASEURL}/chatbox/contact/export?${query}`, authHeader())
        .then((res) => dispatch(contactExportAction(res)))
        .catch((error) => dispatch(contactExportAction(error?.response)));
    } catch (error) {
      console.log('Error exportContacts', error);
    }
  };
};

export const getChatContacts = (params) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams(params).toString();
      await axios
        .get(`${BASEURL}/chatbox/contact/chat?${query}`, authHeader())
        .then((res) => dispatch(contactChatListAction(res)))
        .catch((error) => dispatch(contactChatListAction(error?.response)));
    } catch (error) {
      console.log('Error getChatContacts', error);
    }
  };
};

/* ===================================================================
   CAMPAIGN
=================================================================== */
export const sendCampaign = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${BASEURL}/chatbox/campaign/send-campaign`,
          payload,
          authHeader(),
        )
        .then((res) => {
          toast.success('Campaign Sent Successfully');
          dispatch(campaignSendAction(res));
          dispatch(getAllCampaigns());
        })
        .catch((error) => {
          toast.error(error?.response?.data?.error || 'Something went wrong');
          dispatch(campaignSendAction(error?.response));
        });
    } catch (error) {
      console.log('Error sendCampaign', error);
    }
  };
};

export const getAllCampaigns = () => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/campaign/allCampaigns`, authHeader())
        .then((res) => dispatch(campaignGetAllAction(res)))
        .catch((error) => dispatch(campaignGetAllAction(error?.response)));
    } catch (error) {
      console.log('Error getAllCampaigns', error);
    }
  };
};

export const getCampaignReport = (campaignId) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/campaign/${campaignId}/report`, authHeader())
        .then((res) => dispatch(campaignReportAction(res)))
        .catch((error) => dispatch(campaignReportAction(error?.response)));
    } catch (error) {
      console.log('Error getCampaignReport', error);
    }
  };
};

export const sendSingleMessage = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${BASEURL}/chatbox/campaign/send-single-message`,
          payload,
          authHeader(),
        )
        .then((res) => {
          toast.success('Message Sent Successfully');
          dispatch(campaignSingleSendAction(res));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.error || 'Something went wrong');
          dispatch(campaignSingleSendAction(error?.response));
        });
    } catch (error) {
      console.log('Error sendSingleMessage', error);
    }
  };
};

export const getCampaignLogs = (campaignId) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/campaign/logs/${campaignId}`, authHeader())
        .then((res) => dispatch(campaignLogsAction(res)))
        .catch((error) => dispatch(campaignLogsAction(error?.response)));
    } catch (error) {
      console.log('Error getCampaignLogs', error);
    }
  };
};
export const getDashboardSummary = () => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/campaign/dashboard/summary`, authHeader())
        .then((res) => dispatch(campaignDashboardSummaryAction(res)))
        .catch((error) =>
          dispatch(campaignDashboardSummaryAction(error?.response)),
        );
    } catch (error) {
      console.log('Error getDashboardSummary', error);
    }
  };
};
export const getCampaignReportContacts = (campaignId, status) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/chatbox/campaign/campaignReport/${campaignId}?status=${status}`,
          authHeader(),
        )
        .then((res) => dispatch(campaignReportContactsAction(res)))
        .catch((error) =>
          dispatch(campaignReportContactsAction(error?.response)),
        );
    } catch (error) {
      console.log('Error getCampaignReportContacts', error);
    }
  };
};

/* ===================================================================
   TEMPLATE
=================================================================== */
export const getTemplates = (params = {}) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({
        status: params?.status || 'APPROVED',
        limit: params?.limit || 9,
        ...(params?.after ? { after: params.after } : {}),
        ...(params?.before ? { before: params.before } : {}),
      }).toString();
      await axios
        .get(`${BASEURL}/chatbox/template/getAll?${query}`, authHeader())
        .then((res) => dispatch(templateGetAllAction(res)))
        .catch((error) => dispatch(templateGetAllAction(error?.response)));
    } catch (error) {
      console.log('Error getTemplates', error);
    }
  };
};

export const createTemplate = (payload) => {
  return async (dispatch) => {
    try {
      const res = await axios.post(
        `${BASEURL}/chatbox/template/create`,
        payload,
        authHeader(),
      );
      toast.success('Template Submitted Successfully');
      dispatch(templateCreateAction(res));
      dispatch(getTemplates());
      return res;
    } catch (error) {
      toast.error(
        error?.response?.data?.error ||
          'Failed to create template (backend route not enabled yet)',
      );
      dispatch(templateCreateAction(error?.response));
      return null;
    }
  };
};

/* ===================================================================
   GROUP
=================================================================== */
export const createGroup = (payload, groupLimits) => {
  return async (dispatch) => {
    try {
      await axios
        .post(`${BASEURL}/chatbox/group/create`, payload, authHeader())
        .then((res) => {
          toast.success(res?.data?.message || 'Group Created Successfully');
          dispatch(groupCreateAction(res));
          dispatch(getAllGroups(groupLimits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(groupCreateAction(error?.response));
        });
    } catch (error) {
      console.log('Error createGroup', error);
    }
  };
};
export const getAllGroups = (params) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({
        page: params?.page || 1,
        limit: params?.limit || 10,
        search: params?.search || '',
      }).toString();
      await axios
        .get(`${BASEURL}/chatbox/group/getAll?${query}`, authHeader())
        .then((res) => dispatch(groupGetAllAction(res)))
        .catch((error) => dispatch(groupGetAllAction(error?.response)));
    } catch (error) {
      console.log('Error getAllGroups', error);
    }
  };
};
export const deleteGroup = (id, groupLimits) => {
  return async (dispatch) => {
    try {
      await axios
        .delete(`${BASEURL}/chatbox/group/delete/${id}`, authHeader())
        .then((res) => {
          toast.success(res?.data?.message || 'Group Deleted Successfully');
          dispatch(groupDeleteAction(res));
          dispatch(getAllGroups(groupLimits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(groupDeleteAction(error?.response));
        });
    } catch (error) {
      console.log('Error deleteGroup', error);
    }
  };
};
export const getContactsOfGroup = (id, params) => {
  return async (dispatch) => {
    try {
      const query = new URLSearchParams({
        page: params?.page || 1,
        limit: params?.limit || 10,
        search: params?.search || '',
      }).toString();
      await axios
        .get(`${BASEURL}/chatbox/group/contacts/${id}?${query}`, authHeader())
        .then((res) => dispatch(groupContactsAction(res)))
        .catch((error) => dispatch(groupContactsAction(error?.response)));
    } catch (error) {
      console.log('Error getContactsOfGroup', error);
    }
  };
};
export const getGroupById = (id) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/group/get/${id}`, authHeader())
        .then((res) => dispatch(groupGetByIdAction(res)))
        .catch((error) => dispatch(groupGetByIdAction(error?.response)));
    } catch (error) {
      console.log('Error getGroupById', error);
    }
  };
};
export const addContactToGroup = (groupId, contactIds, groupLimits) => {
  return async (dispatch) => {
    try {
      await axios
        .post(
          `${BASEURL}/chatbox/group/add-contact/${groupId}`,
          { contactIds },
          authHeader(),
        )
        .then((res) => {
          toast.success(res?.data?.message || 'Contact(s) Added To Group');
          dispatch(groupAddContactAction(res));
          dispatch(getAllGroups(groupLimits));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(groupAddContactAction(error?.response));
        });
    } catch (error) {
      console.log('Error addContactToGroup', error);
    }
  };
};

/* ===================================================================
   MESSAGE (CHAT)
=================================================================== */
export const sendChatMessage = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .post(`${BASEURL}/chatbox/message/send`, payload, authHeader())
        .then((res) => {
          dispatch(messageSendAction(res));
        })
        .catch((error) => {
          toast.error(
            error?.response?.data?.message || 'Failed to send message',
          );
          dispatch(messageSendAction(error?.response));
        });
    } catch (error) {
      console.log('Error sendChatMessage', error);
    }
  };
};

export const getChatMessages = (phoneNumber) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/chatbox/message?phoneNumber=${phoneNumber}`,
          authHeader(),
        )
        .then((res) => dispatch(messageGetChatAction(res)))
        .catch((error) => dispatch(messageGetChatAction(error?.response)));
    } catch (error) {
      console.log('Error getChatMessages', error);
    }
  };
};

/* ===================================================================
   MEDIA
=================================================================== */
export const uploadMedia = (file) => {
  return async (dispatch) => {
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post(
        `${BASEURL}/chatbox/media/upload-sample-media`,
        fd,
        authHeader(),
      );
      dispatch(mediaUploadAction(res));
      return res?.data?.message; // mediaId returned by backend
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Image upload failed');
      dispatch(mediaUploadAction(error?.response));
      return null;
    }
  };
};

/* ===================================================================
   CREDENTIALS
=================================================================== */
export const getCredentials = () => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/chatbox/credential/get`, authHeader())
        .then((res) => dispatch(credentialsGetAction(res)))
        .catch((error) => dispatch(credentialsGetAction(error?.response)));
    } catch (error) {
      console.log('Error getCredentials', error);
    }
  };
};
